import { useState, useEffect } from 'react';
import { Modal, Spinner, Badge } from 'react-bootstrap';
import { fetchMovimentacoesDetalhe } from '../../services/api';
import styles from './MovimentacoesModal.module.css';

const formatarPreco = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const formatarData = (d) => {
  if (!d) return '-';
  const [y, m, day] = d.split('-');
  return `${day}/${m}/${y}`;
};

const MovimentacoesModal = ({
  show, onHide, tipo, loja, codLocal, startDate, endDate,
  dadosPreCarregados = null,   // se fornecido, usa direto (sem fetch) — ex.: pedidos e-commerce
  titulo: tituloProp,
  cor: corProp,
  icone: iconeProp,
  unidade = 'boletas',
  negativo = true,             // false p/ vendas (e-commerce): valor sem o "-"
}) => {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandidos, setExpandidos] = useState({});

  const titulo = tituloProp ?? (tipo === 'cancelamentos' ? 'Cancelamentos' : 'Trocas');
  const cor = corProp ?? (tipo === 'cancelamentos' ? '#ff6b6b' : '#ffa94d');
  const icone = iconeProp ?? (tipo === 'cancelamentos' ? '🚫' : '🔄');
  const sinal = negativo ? '-' : '';

  useEffect(() => {
    if (!show) return;
    setExpandidos({});
    // Dados já prontos no client (ex.: pedidos e-commerce) → sem fetch
    if (dadosPreCarregados) {
      setDados(dadosPreCarregados);
      setLoading(false);
      return;
    }
    setDados([]);
    setLoading(true);
    fetchMovimentacoesDetalhe({ tipo, loja: codLocal, startDate, endDate })
      .then(res => {
        if (res.success) setDados(res.data || []);
      })
      .finally(() => setLoading(false));
  }, [show, tipo, codLocal, startDate, endDate, dadosPreCarregados]);

  const toggleBoleta = (boleta) =>
    setExpandidos(prev => ({ ...prev, [boleta]: !prev[boleta] }));

  const totalGeral = dados.reduce((s, b) => s + (b.valorTotal || 0), 0);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable className={styles.modal}>
      <Modal.Header closeButton className={styles.header}>
        <Modal.Title className={styles.title}>
          <span style={{ color: cor }}>{icone} {titulo}</span>
          <span className={styles.subtitle}>
            {loja} &bull; {formatarData(startDate)} – {formatarData(endDate)}
          </span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={styles.body}>
        {loading && (
          <div className={styles.centered}>
            <Spinner animation="border" size="sm" /> Carregando...
          </div>
        )}

        {!loading && dados.length === 0 && (
          <div className={styles.centered}>Nenhum registro encontrado no período.</div>
        )}

        {!loading && dados.length > 0 && (
          <>
            <div className={styles.resumo}>
              <span><strong>{dados.length}</strong> {unidade}</span>
              <span style={{ color: cor }}><strong>{formatarPreco(totalGeral)}</strong></span>
            </div>

            <div className={styles.lista}>
              {dados.map((boleta) => (
                <div key={boleta.boleta} className={styles.boletaCard}>
                  <button
                    className={styles.boletaHeader}
                    onClick={() => toggleBoleta(boleta.boleta)}
                  >
                    <div className={styles.boletaInfo}>
                      <span className={styles.boletaData}>{formatarData(boleta.data)}</span>
                      {boleta.hora && (
                        <span className={styles.boletaHora}>{boleta.hora.substring(0, 5)}</span>
                      )}
                      <span className={styles.boletaNum}>#{boleta.boleta}</span>
                      {boleta.nomeCliente ? (
                        <span className={styles.boletaCliente} title={`Cod. ${boleta.codigoCliente}`}>
                          {boleta.nomeCliente}
                        </span>
                      ) : boleta.operador && (
                        <span className={styles.boletaOperador}>{boleta.operador}</span>
                      )}
                    </div>
                    <div className={styles.boletaRight}>
                      <Badge bg="secondary" className={styles.boletaBadge}>
                        {boleta.totalItens} {boleta.totalItens === 1 ? 'item' : 'itens'}
                      </Badge>
                      <span className={styles.boletaValor} style={{ color: cor }}>
                        {sinal}{formatarPreco(boleta.valorTotal)}
                      </span>
                      <span className={styles.chevron}>
                        {expandidos[boleta.boleta] ? '▲' : '▼'}
                      </span>
                    </div>
                  </button>

                  {expandidos[boleta.boleta] && (
                    <div className={styles.itensContainer}>
                      <table className={styles.itensTable}>
                        <thead>
                          <tr>
                            <th>Código</th>
                            <th>Qtd</th>
                            <th>Vl. Unit.</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {boleta.itens.map((item, i) => (
                            <tr key={i}>
                              <td className={styles.codCell}>{item.codigoProduto}</td>
                              <td className={styles.numCell}>{item.quantidade}</td>
                              <td className={styles.numCell}>{formatarPreco(item.valorUnitario)}</td>
                              <td className={styles.numCell} style={{ color: cor }}>
                                {sinal}{formatarPreco(item.valorTotal)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="3" className={styles.totalLabel}>Total</td>
                            <td className={styles.numCell} style={{ color: cor, fontWeight: 700 }}>
                              {sinal}{formatarPreco(boleta.valorTotal)}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default MovimentacoesModal;
